import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { fontRoboto } from "@product/scmp-sdk";

import { Loading } from "~/components/common/loading";

export const Container = styled.div`
  display: inline-flex;
  align-items: center;

  padding-block: 16px;
  padding-inline: 20px;

  font-family: ${fontRoboto};

  border-radius: 40px;

  background-color: #f2f2f2;

  ${props => props.theme.breakpoints.up("desktop")} {
    padding: 20px;
  }
`;

export const Text = styled.div`
  margin-inline-end: 30px;

  font-size: 14px;
  line-height: 16px;
`;

export const SwitchTrack = styled.span`
  position: absolute;

  display: block;

  inline-size: 100%;
  block-size: 100%;

  border-radius: 16px;

  background: #cccccc;
`;

export const SwitchThumb = styled.span`
  position: relative;
  inset-block-start: 2px;
  inset-inline-start: 2px;

  display: block;

  inline-size: 27px;
  block-size: 27px;

  border-radius: 16px;

  background-color: #ffffff;

  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 120ms;

  ${props => props.theme.breakpoints.up("desktop")} {
    inline-size: 20px;
    block-size: 20px;
  }
`;

export const SwitchInput = styled.input`
  position: absolute;
  inset-block-start: 0;
  inset-inline-start: 0;
  z-index: 1;

  inline-size: 100%;
  block-size: 100%;
  margin: 0;

  cursor: inherit;

  opacity: 0;
`;

type Props = {
  $isChecked: boolean;
  $isHidden: boolean;
};

export const SwitchRoot = styled.span<Props>`
  position: relative;

  display: inline-block;

  inline-size: 51px;
  block-size: 31px;
  margin: 0;

  font-size: 0;

  cursor: pointer;

  ${props =>
    props.$isChecked &&
    css`
      ${props.theme.breakpoints.up("desktop")} {
        ${SwitchThumb} {
          inset-inline-start: 15px;
        }
      }

      ${SwitchThumb} {
        left: 15px;
        top: 2px;
      }
      ${SwitchTrack} {
        background-color: #001246;
      }
    `}

  ${props => props.theme.breakpoints.up("desktop")} {
    inline-size: 37px;
    block-size: 24px;
  }
`;

export const StyledLoading = styled(Loading)`
  inline-size: 24px;
  block-size: 24px;
  img {
    object-fit: contain;
  }
`;
